import { setupWorker } from 'msw/browser';

import { teHandlers, kbHandlers } from './handlers';

export const enableMocking = (enable = false) => {
    if (process.env.NODE_ENV !== 'development' || !enable) {
        return Promise.resolve();
    }

    const handlers = process.env.npm_lifecycle_event?.startsWith('start:mocked:kb') ? kbHandlers : teHandlers;

    return setupWorker(...handlers).start({
        onUnhandledRequest: (req, print) => {
            const url = new URL(req.url);
            if (url.pathname.startsWith('/kredittbank-kredittkort-betjening-web/')) {
                print.warning();
            }
        },
    });
};
